import angularModule from 'Authentication/angularModule/scripts/authentication_module';
import { getMobileAuthToken } from 'MobileAuthToken';
import Auid from 'Auid';

angularModule.factory('AuthenticationInterceptor', [
    '$injector',

    $injector => {
        const $rootScope = $injector.get('$rootScope');

        return {
            request(config) {
                config.headers = config.headers || {};
                config.headers.auid = Auid.ensure($rootScope.currentUser);

                if (window.CORDOVA) {
                    const authToken = getMobileAuthToken();
                    if (authToken) config.headers.Authorization = `Bearer ${authToken}`;
                }

                return config;
            },
        };
    },
]);

angularModule.config([
    '$injector',
    $injector => {
        const PrioritizedInterceptorsProvider = $injector.get('PrioritizedInterceptorsProvider');
        PrioritizedInterceptorsProvider.addInterceptor(-1, 'AuthenticationInterceptor');
    },
]);
